import { render, staticRenderFns } from "./ViewVendorDetailpopup.vue?vue&type=template&id=451dd585"
import script from "./ViewVendorDetailpopup.vue?vue&type=script&lang=js"
export * from "./ViewVendorDetailpopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports